import { Typography } from '@navi/web-ui/lib/primitives';
import styles from '../../AgentForm.module.scss';
import { IAgentRolesFormProps } from '../../interfaces/types';
import { NAVI_AGENCY_CODE, VALIDATION_MESSAGE } from '../../constants/constants';
import AgentFormAutocompleteDropdown from './AgentFormAutocompleteDropdown';
import { convertToDropdownOptions } from '../../utils/utils';
import AgentFormRolesDropdown from './AgentFormRolesDropdown';
import { useSelector } from 'react-redux';
import { RootState } from '@cp/src/store';
import { Roles } from '@cp/src/pages/auth/constants/AuthConstants';
import AgentFormTextbox from './AgentFormTextbox';

const AgentRolesForm = (props: IAgentRolesFormProps) => {
  const {
    isAgentActive,
    control,
    errors,
    isEditDisabled,
    AGENCIES_REPORTING,
    setValue,
    AVAILABLE_ROLES_LIST,
    isUserManagementRole
  } = props;

  const isCreateUserFeatureFlag = useSelector(
    (store: RootState) => store.common.featureFlags?.createUserFeatureFlag
  );
  const userAgencyCode = useSelector((store: RootState) => store.common?.userData?.agencyCode);
  const userRoles = useSelector((store: RootState) => store.common?.userData?.roles);

  const isExternalAgent = userAgencyCode !== NAVI_AGENCY_CODE;
  const isExternalTeamLead = isExternalAgent && userRoles?.includes(Roles.ROLE_TEAM_LEAD);

  return (
    <div className={styles.agentRoleDetailsContainer}>
      <div>
        <Typography variant={'h4'} color="var(--navi-color-gray-c2)" className="pl-5 pt-5">
          Agent access/agency code
        </Typography>
        <div className={styles.activeContainer} hidden={!isAgentActive}>
          <div>
            <div className={styles.inputContainer}>
              <AgentFormRolesDropdown
                control={control}
                name={'roles'}
                errors={errors}
                isEditDisabled={isEditDisabled || !isCreateUserFeatureFlag}
                styles={styles}
                validationMessage={VALIDATION_MESSAGE.AGENT_ACCESS_MESSAGE}
                options={AVAILABLE_ROLES_LIST}
              />
            </div>
            {isUserManagementRole && (
              <div className={styles.inputContainer}>
                <AgentFormAutocompleteDropdown
                  control={control}
                  name={'agencyCodeRequested'}
                  inputLabel={'Agency Code'}
                  rules={{ required: true }}
                  errors={errors}
                  placeholder={'Type or Select agency code'}
                  isEditDisabled={isEditDisabled}
                  styles={styles}
                  validationMessage={VALIDATION_MESSAGE.AGENCY_CODE_MESSAGE}
                  options={convertToDropdownOptions(AGENCIES_REPORTING)}
                  updateClearAllCallback={() => {
                    setValue('agencyCodeRequested', '');
                  }}
                />
              </div>
            )}
            {!isUserManagementRole && isExternalTeamLead && (
              <div className={styles.inputContainer}>
                <AgentFormTextbox
                  control={control}
                  name={'agencyCodeRequested'}
                  inputLabel={'Agency Code'}
                  rules={{ required: true }}
                  errors={errors}
                  isEditDisabled={true}
                  styles={styles}
                  placeholder={''}
                  validationMessage={''}
                />
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default AgentRolesForm;
